import script from "./AlterLeavingForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlterLeavingForm.vue?vue&type=script&setup=true&lang=ts"

import "./AlterLeavingForm.vue?vue&type=style&index=0&id=66859064&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66859064"]])

export default __exports__